<template>
    <div class="navbar-container">
        <nav>
            <router-link to="/" class="nav-link">
                <span class="nav-dot"></span>
                설문 주문
            </router-link>
            <router-link to="/list" class="nav-link">
                <span class="nav-dot"></span>
                진행중인 설문
            </router-link>
            <router-link to="/knowhow" class="nav-link">
                <span class="nav-dot"></span>
                블로그
            </router-link>
            <a class="nav-link nav-contact" @click="contactModal = true">문의하기</a>
        </nav>

        <div class="navbar-actions">
            <div class="join-pill">
                <span>설문 참여하기</span>
                <a href="https://play.google.com/store/apps/details?id=com.surveasy.surveasy" target="_blank" class="join-pill-link">Android</a>
                <a href="https://apps.apple.com/kr/app/%EC%84%9C%EB%B2%A0%EC%9D%B4%EC%A7%80/id1614071000" target="_blank" class="join-pill-link">iOS</a>
            </div>
            <a class="order-button" @click="openOrderModal()">설문 주문하기</a>
        </div>

        <HomeContactModal :contactModal="contactModal" @closeContact="contactModal = false" />
    </div>
</template>


<script>
import HomeContactModal from '@/components/Home/HomeContactModal.vue'
import { openOrderModal } from '@/plugins/order-modal'
export default {
    name: 'HomeNavBar',
    components: {
        HomeContactModal
    },
    data() {
        return {
            contactModal: false
        }
    },
    methods: {
        openOrderModal
    }
}
</script>


<style scoped>
.navbar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    font-family: var(--font-sans);
    padding: 16px 20px;
    box-sizing: border-box;
}

nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 18px;
}

.nav-link {
    font-weight: var(--font-weight-medium);
    font-size: 14px;
    color: var(--ink-700);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}

.nav-link:hover {
    color: var(--ink-900);
}

.nav-link.router-link-exact-active {
    color: var(--green-600);
    font-weight: var(--font-weight-semibold);
}

.nav-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: var(--green-500);
    display: inline-block;
    opacity: 0;
    transition: opacity .15s ease;
}

.nav-link.router-link-exact-active .nav-dot {
    opacity: 1;
}

.nav-contact {
    color: var(--ink-400);
}

.navbar-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.join-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: var(--ink-900);
    color: var(--white);
    border-radius: var(--radius-md);
    padding: 8px 14px;
    font-size: 13px;
    font-weight: var(--font-weight-medium);
    white-space: nowrap;
}

.join-pill-link {
    color: var(--white);
    text-decoration: underline;
    font-weight: var(--font-weight-semibold);
}

.order-button {
    background-color: var(--green-500);
    color: var(--white);
    border: 1px solid var(--green-500);
    border-radius: var(--radius-md);
    padding: 9px 16px;
    font-size: 14px;
    font-weight: var(--font-weight-semibold);
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0 6px 18px rgba(12, 174, 2, 0.24);
}

.order-button:hover {
    background-color: var(--green-600);
    border-color: var(--green-600);
}

@media (max-width: 480px) {
    .navbar-container {
        justify-content: center;
        padding: 12px;
    }

    nav {
        justify-content: center;
        gap: 12px;
    }
}

/*
  900px 미만(모바일)에서는 하단 탭바(홈/주문/리스트/리서치노하우)가 같은
  목적지로 가는 진입점을 이미 제공한다. 여기 있는 "설문 참여하기"
  Android/iOS pill + "설문 주문하기" 버튼까지 같이 두면 화면 위쪽이 버튼
  두 줄로 꽉 차서 정작 본문은 스크롤해야 보였다 — 모바일에서는 숨긴다.
*/
@media (max-width: 900px) {
    .navbar-actions {
        display: none;
    }
}
</style>
